var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.313,
    height: 14.312,
    viewBox: "0 0 14.313 14.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy-course-svgrepo-com",
    d: "M0,14.312H10.942V3.369H0V14.312Zm10.1-10.1V13.47H.842V4.211H10.1ZM14.313,0V10.943H11.787V10.1h1.683V.842H4.212V2.525H3.369V0ZM2.525,7.581H8.417V6.739H2.525v.842Zm0,3.362H8.417V10.1H2.525v.843Zm0-1.682H6.734V8.42H2.525v.842Z",
    fill: "#09448d",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleCourses);
export default __webpack_public_path__ + "static/media/multiple_courses.b75ff9ae05948b5d9d0371c0106de33c.svg";
export { ForwardRef as ReactComponent };